//#region Imports

import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconComponent } from '../icon/icon.component';
import { NgClass } from "@angular/common";

//#endregion

@Component({
  selector: 'l-course-module-card',
  standalone: true,
  templateUrl: './course-module-card.component.html',
  imports: [CdkDragHandle, FormsModule, IconComponent, NgClass],
})
export class CourseModuleCardComponent {

  //#region Inputs

  @Input({ required: true })
  public moduleIndex: number = 1;

  @Input()
  public name: string = '';

  @Input()
  public ghost: boolean = false;

  @Input()
  public preview: boolean = false;

  @Input()
  public showActivationToggle: boolean = false;

  @Input()
  public isActive: boolean = true;

  //#endregion

  //#region Outputs

  @Output()
  public nameChange: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  public delete: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public isActiveChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  //#endregion

  //#region Getters

  public get activationLabel(): string {
    return this.isActive ? 'Desativar' : 'Ativar';
  }

  //#endregion

  //#region Public Methods

  public onNameChange(value: string): void {
    this.nameChange.emit(value);
  }

  public onDelete(): void {
    this.delete.emit();
  }

  public onToggleActive(event: Event): void {
    event.stopPropagation();
    this.isActiveChange.emit(!this.isActive);
  }

  //#endregion

}
